import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div class="fallback svelte-c34ephgu7mj5"><span class="wordmark svelte-c34ephgu7mj5">eigenvisuals</span> <p class="svelte-c34ephgu7mj5">This artwork is drawn with WebGL2, which this browser doesn't support.</p></div>`);

export default function Fallback($$anchor) {
	var // Static WebGL2-unavailable screen — no state.
	div = root();

	$.append($$anchor, div);
}
import "bun-svelte:Fallback.svelte-2m6kmoktauvdy-style.css";